export default {"src":"/_next/static/media/clouds_menu_select.58749d22.svg","height":464,"width":2209,"blurWidth":0,"blurHeight":0};